<script>

export const BaseLayoutResultGeneric = {
  props: ["title", "id"],
  components: {
  },

  render() {
    return (
      <b-container key={this.$props.id} class="base-generic-components-card">
        <b-container>
          <h2 >{this.$props.title}</h2>
          <div class="span-new"></div>
        </b-container>

        <b-container>
          <div>
            {this.$slots.body}
          </div>
        </b-container>
      </b-container>
    );
  },
};

export default BaseLayoutResultGeneric;
</script>

<style lang="scss" scoped>
.span-new {
  width: 100%;
  height: 0.15rem;
  border-radius: 20%;
  background-color: var(--secondary-green);
  margin-bottom: 3rem;
  margin-top: 1.5rem;
}
</style>
